import { makeFragmentData } from '@packages/gql/generated/shopping';
import {
  SampleOrderLinkFragmentFragmentDoc,
  type SampleOrderLinkFragmentFragment,
} from '@packages/gql/generated/shopping/graphql';

export const sampleOrderLinkDataMock: SampleOrderLinkFragmentFragment = {
  akl: 'AKLBB761176388',
  sku: '9669202279-40-761176388',
  sampleOrderType: 'WOOD',
};

export function getSampleOrderLinkFragmentedData(data?: SampleOrderLinkFragmentFragment) {
  return makeFragmentData(data || sampleOrderLinkDataMock, SampleOrderLinkFragmentFragmentDoc);
}
